(function() {

  // ANCHOR Separation Section
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const animation = entry.target.dataset.animation;
      (entry.isIntersecting) ?
        entry.target.classList.add(animation) :
        entry.target.classList.remove(animation);
    });
  }, {threshold: 0.5});

  document.querySelectorAll('[data-animation]').forEach(intersect => observer.observe(intersect));

  // ANCHOR Slider Section

  const swiper = new Swiper('.beet-slider__slider', {
    // Optional parameters

    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },


  });
  
  // ANCHOR TIMELINE

  const slides = document.querySelectorAll('.bts-slide');
  slides.forEach(slide => slide.style.width = `${(100 / slides.length)}%`);

  // const timeline = document.querySelector(".beet-timeline-wrapper");
  // const timelineIndicator = document.querySelector(".bts-anchor");
  // let isTrackpad = false;
  // // console.log("🚀 ~ file: beet-landing.js:36 ~ timelineIndicator", timelineIndicator)
  // const body = document.body;

  // const scrollObserver = new IntersectionObserver(entries => {
  //   entries.forEach(entry => {
  //     // console.log('entry.Intersecting', entry.target)
  //     if(body.classList.contains('scrolling')) return;
  //     // console.log(entry.isIntersecting)
  //     if (entry.isIntersecting) {
  //       // console.log('bind')
  //       // body.style.overflowY = "hidden";
  //       // bindMouseWheel(timeline);

  //       Observer.create({
  //         target: timeline,
  //         type: "wheel",
  //         onChangeY: (self) => {
  //           document.documentElement.scrollLeft += self.deltaY;
  //         }
  //       });
  //     } else {
  //       // console.log('unbind')
  //       // unbindMouseWheel(timeline);
  //     }
  //   });
  // }, { threshold: 1 });

  // scrollObserver.observe(timelineIndicator);

  // function bindMouseWheel(element) {
  //   body.classList.add('scrolling')
  //   // element.scrollIntoView({behavior: "smooth", block: "start"})
  //   // document.querySelector('#beet-2021').scrollIntoView();
  //   element.addEventListener("wheel", handleWheel);
  //   element.addEventListener("touchstart", handleTouchStart);
  //   element.addEventListener("touchmove", handleTouchMove);
  //   element.addEventListener("touchend", handleTouchEnd);
  //   document.addEventListener("wheel", globalScroll);
  // }

  // function unbindMouseWheel(element) {
  //   body.classList.remove('scrolling')
  //   // body.style.overflowY = "auto";
  //   element.removeEventListener("wheel", handleWheel);
  //   element.removeEventListener("touchstart", handleTouchStart);
  //   element.removeEventListener("touchmove", handleTouchMove);
  //   element.removeEventListener("touchend", handleTouchEnd);
  //   document.removeEventListener("wheel", globalScroll);
  // }

  // function globalScroll(event) {
  //   detectTrackPad(event);
  //   let delta = event.deltaY;
  //   // console.log(Math.abs(event.deltaY) < 1)
  //   if (isTrackpad) {
  //     delta = event.deltaY * 40;
  //   }
    
  //   if(timeline.scrollLeft === 0 && delta < 0) {
  //     timelineIndicator.style.left = `${timeline.scrollLeft}px`;
  //     unbindMouseWheel(timeline);
  //     return;
  //   }

  //   if (timeline.scrollLeft >= timeline.scrollWidth - timeline.offsetWidth && delta > 0) {
  //     timelineIndicator.style.left = `${timeline.scrollLeft}px`;
  //     unbindMouseWheel(timeline);
  //     return;
  //   }
    
  //   // event.preventDefault();
  //   timeline.scrollLeft += delta;
  //   timelineIndicator.style.left = `${timeline.scrollLeft}px`;
  // }

  // function handleWheel(event) {
  //   // event.preventDefault();
  //   // console.log(Math.abs(event.deltaY) < 1)
  //   detectTrackPad(event);
  //   let delta = event.deltaY;
  //   // console.log(isTrackpad)
  //   if (isTrackpad) {
  //     delta = event.deltaY * 40;
  //   }
  //   if (this.scrollLeft === 0 && delta < 0) {
  //     timelineIndicator.style.left = `${this.scrollLeft}px`;
  //     unbindMouseWheel(this);
  //     return;
  //   }

  //   if (this.scrollLeft >= this.scrollWidth - this.offsetWidth && delta > 0) {
  //     timelineIndicator.style.left = `${this.scrollLeft}px`;
  //     unbindMouseWheel(this);
  //     return;
  //   }

  //   event.preventDefault();
  //   this.scrollLeft += delta;
  //   setTimeout(() => timelineIndicator.style.left = `${this.scrollLeft}px`, 0);
  // }

  // function handleTouchStart(event) {
  //   this.touchX = event.touches[0].clientX;
  //   this.scrollLeft = this.scrollLeft === 0 ? 100 : this.scrollLeft;
  //   timelineIndicator.style.left = `${this.scrollLeft}px`;
  // }

  // function handleTouchMove(event) {
  //   if (event.cancelable) event.preventDefault();

  //   const touchMoveX = event.touches[0].clientX;
  //   const swipeDistance = touchMoveX - this.touchX;
  //   const swipeDirection = swipeDistance > 0 ? 'right' : 'left';
  
  //   // update the scroll position based on the swipe direction
  //   if (swipeDirection === 'right') {
  //     this.scrollLeft -= Math.abs(swipeDistance);
  //   } else if (swipeDirection === 'left') {
  //     this.scrollLeft += Math.abs(swipeDistance);
  //   }

  //   // console.dir('HandleMove Start');
  //   // this.scrollLeft -= event.touches[0].clientX - this.touchX;
  //   // console.log(this.scrollLeft)

  //   // this.touchX = event.touches[0].clientX;
  //   const scrollPosition = this.scrollLeft + (this.offsetWidth / 2);
  //   // console.log("🚀 ~ file: beet-landing.js:130 ~ handleTouchMove ~ scrollPosition", scrollPosition)
  //   timelineIndicator.style.left = `${scrollPosition - (timelineIndicator.offsetWidth / 2)}px`;

  //   if (this.scrollLeft === 0 || this.scrollLeft === this.scrollWidth - this.offsetWidth) {
  //     // console.dir('HandleMove if');
  //     timelineIndicator.style.left = `${this.scrollLeft}px`;
  //     unbindMouseWheel(this);
  //   }
  // }

  // function handleTouchEnd(event) {
  //   if (this.scrollLeft === 0 || this.scrollLeft === this.scrollWidth - this.offsetWidth) {
  //     // console.log('handleEnd', this.scrollLeft, this.scrollLeft === this.scrollWidth - this.offsetWidth )
  //     unbindMouseWheel(this);
  //   }

  //   timelineIndicator.style.left = `${this.scrollLeft}px`;
  // };

  // function detectTrackPad(e) {
  //   isTrackpad = e.wheelDeltaY ? e.wheelDeltaY === -3 * e.deltaY : e.deltaMode === 0
  //   // your code
  //    console.log(isTrackpad ? "Trackpad detected" : "Mousewheel detected");
  // }

})();